// MRTViewer.tsx
import { useEffect } from 'react';

const MRTViewer = () => {
  useEffect(() => {
    // Set license key if needed
    // window.Stimulsoft.Base.StiLicense.key = "YOUR_LICENSE_KEY";

    const options = new window.Stimulsoft.Viewer.StiViewerOptions();
    options.appearance.fullScreenMode = true;

    const viewer = new window.Stimulsoft.Viewer.StiViewer(options, 'StiViewer', false);
    const report = new window.Stimulsoft.Report.StiReport();

    // Load MRT file from public path
    report.loadFile('/reports/report.mrt');

    viewer.report = report;
    viewer.renderHtml('viewerContainer');
  }, []);

  return <div id="viewerContainer" style={{ height: '100vh', width: '100%' }} />;
};

export default MRTViewer;
